import { render, staticRenderFns } from "./DetailCardCPD.vue?vue&type=template&id=ce22f2ba&scoped=true&"
import script from "./DetailCardCPD.vue?vue&type=script&lang=js&"
export * from "./DetailCardCPD.vue?vue&type=script&lang=js&"
import style0 from "./DetailCardCPD.vue?vue&type=style&index=0&id=ce22f2ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce22f2ba",
  null
  
)

export default component.exports